export const fileFromBase64String = async (strData: string, filename: string, mimeType: string) => {
  const fileUrl = `data:${mimeType};base64,${strData}`;
  const fileBlob = await (await fetch(fileUrl)).blob();

  return new File([fileBlob], filename, { type: mimeType });
};

export const openObjectInNewWindow = (obj: Blob | MediaSource) => {
  const objUrl = URL.createObjectURL(obj);
  const windowProxy = window.open(objUrl, '_blank');

  if (windowProxy) {
    windowProxy.onbeforeunload = () => {
      URL.revokeObjectURL(objUrl);
    };
  }
};

export const saveFile = (file: Blob, filename: string) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');

  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
};
